import React from 'react';
import './roadmap.css';
import Image from '../Image';
import Icon from '../Icon';

const RoadmapIcon = ({ color, alt, name }) => {
  return (
    <div className="roadmap_icon">
      <Icon name={name} key={alt} color={color} style={{ color }} />
    </div>
  );
};

const RoadmapStat = ({ top, mid, bot, color }) => {
  return (
    <div className="roadmap_stat" style={{ color }}>
      {top && <p className="roadmap_stat_top">{top}</p>}
      {mid && <p className="roadmap_stat_mid">{mid}</p>}
      {bot && <p className="roadmap_stat_bot">{bot}</p>}
    </div>
  );
};

export { RoadmapIcon, RoadmapStat };



// WEBPACK FOOTER //
// ./src/Components/Roadmap/index.js